<app-menu-template3>
  <main class="container-12">
    <article class="row ml-5 mr-5 mt-4 mb-3 rounded shadow bg-white">
      <header class="col-3 text-center solicitudes-bg d-flex flex-column justify-content-around">
        <header class="mt-5">
          <figure>
            <div class="bg-light solicitudes-logo p-4" *ngIf="datoSolicitudSharedModel.data && datoSolicitudSharedModel.data.codigo_camara || municipio_id || datoSolicitudSharedModel.tipo_rnt === guia">
              <img [src]="camaraUrl" class="m-auto img-fluid solicitudes-bg-max" alt="" height="80" />
            </div>
            <figcaption class="mt-3">
              <label class="h5 text-white" *ngIf="datoSolicitudSharedModel.tipo_solicitud === tipo_nueva">Solicitud
                de inscripción</label>
              <label class="h5 text-white" *ngIf="datoSolicitudSharedModel.tipo_solicitud === tipo_renovacion">Solicitud
                de renovación</label>
              <label class="h5 text-white" *ngIf="datoSolicitudSharedModel.tipo_solicitud === tipo_solicitud_actualizacion">Solicitud
                de actualización</label>
              <label class="h5 text-white" 
                    *ngIf="
                            datoSolicitudSharedModel.tipo_solicitud === tipo_reactivacion">Solicitud
                  de reactivación+renovación</label>
            </figcaption>
          </figure>
        </header>
        <section>
          <ul class="nav flex-column">
            <li class="nav-item" *ngFor="let item of totalPasos; let i=index">
              <label class="nav-link solicitudes-pasos" [ngClass]="{'solicitudes-pasos-active': pasoActual === (i+1)}">
                <i class="solicitudes-pasos-circulo mr-2"></i>
                Paso {{i+1}}
              </label>
            </li>
          </ul>
        </section>
        <footer>
          <a class="nav-link text-white" [routerLink]="['/mis-establecimientos']" routerLinkActive="router-link-active">Regresar
            a Mis RNT</a>
        </footer>
      </header>
      <section class="col-9">
        <router-outlet (activate)="onPasoActual($event)"></router-outlet>
      </section>
    </article>
  </main>
</app-menu-template3>
